import React from 'react';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import {
  SOLICITATION_STATUSES,
  SOLICITATION_PROCESS,
  TO_CONTINUE_FIELD,
} from '../constants';
import { RENEW_SOLICITATION } from '../queries';
import solicitationNotifications from '../utils/solicitation-notification-helpers';
import UpiidDetailsForm from '../components/upiid-details/upiid-details-form';
import { getUpiidDetailsNextPath } from '../utils/solicitation-helpers';
import { useUpiidDetails } from '../components/upiid-details/upiid-details-provider';
import { pageErrorNotifications } from '../../../utilities/error-handling';

const RenewSolicitationForm = () => {
  const navigate = useNavigate();
  const setSolicitationNotification = useSetRecoilState(
    solicitationNotifications,
  );
  const { solicitation } = useUpiidDetails();

  const [renewSolicitation] = useMutation(RENEW_SOLICITATION, {
    onError: (requestError) => {
      setSolicitationNotification([
        ...pageErrorNotifications(requestError, {
          id: 'RENEW_SOLICITATION_ERROR',
          message: requestError.message,
          type: 'error',
          closeable: false,
          showInModal: false,
        }),
      ]);
    },
  });

  const onSubmit = (data) => {
    void renewSolicitation({
      variables: {
        year: Number(data.contractYear),
        input: {
          solicitationID: Number(solicitation.id),
          solicitationNumber: (data.upiidAAC + data.upiidSQ).toUpperCase(),
          title: data.solicitationTitle,
          purchaseTypeCode: data.purchaseType,
          solicitationType: SOLICITATION_PROCESS.RENEWAL,
          description: data.solicitationDescription,
          status: SOLICITATION_STATUSES.Draft,
          samUrl: data.solicitationPosting,
        },
      },
      onCompleted: (response) => {
        if (response.renewSolicitation) {
          const {
            bidType,
            id: renewSolId,
            solicitationNumber,
            contractYear,
          } = response.renewSolicitation;
          setSolicitationNotification([
            {
              id: 'RENEW_SOLICITATION',
              message: (
                <>
                  <b> Solicitation {solicitationNumber}</b> was successfully
                  renewed for {contractYear}.
                </>
              ),
              type: 'success',
              closeable: true,
              showInModal: false,
              showOnNextPage: true,
            },
          ]);
          navigate(
            getUpiidDetailsNextPath(
              bidType,
              renewSolId,
              !data[TO_CONTINUE_FIELD],
            ),
          );
        }
      },
    });
  };

  return (
    <UpiidDetailsForm
      formId="renew-solicitation-form"
      onSubmit={onSubmit}
      solicitation={solicitation}
      isRenewal={true}
    />
  );
};

export default RenewSolicitationForm;
